import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import "./BlogSection.css";
import blog1 from "../assets/digital.jpg";
import blog2 from "../assets/Businesses Optimize.jpg";
import blog3 from "../assets/IT Infrastructure.jpg";

// Blog Data with directions
const blogPosts = [
 {
  id: 1,
  image: blog1,
  category: "Project Management",
  title: "Driving Digital Transformation with Strat Edge’s Proven Expertise",
  author: "Strat Edge Team",
  authorIcon: <FaUserCircle />,
  animation: { x: -80, y: 0 }, // Slide from left
},
{
  id: 2,
  image: blog2,
  category: "Consultancy",
  title: "How Strat Edge Helps UAE Businesses Optimize Processes & Operations",
  author: "Strat Edge Team",
  authorIcon: <FaUserCircle />,
  animation: { x: 80, y: 0 }, // Slide from right
},
{
  id: 3,
  image: blog3,
  category: "Technology",
  title: "Enabling Mission-Critical IT Infrastructure Across Government & Enterprises",
  author: "Strat Edge Team",
  authorIcon: <FaUserCircle />,
  animation: { x: 0, y: 80 }, // Slide from bottom
},

];

// Parent container for stagger
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2, // delay between children
    },
  },
};

// Each card animation
const cardVariants = (animation) => ({
  hidden: { opacity: 0, ...animation },
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
});

const BlogSection = () => {
  return (
    <section className="blog-section py-5">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <p className="section-subtitle">OUR BLOG</p>
            <h2 className="section-title2">
              Latest News & Articles From <br /> the Blog
            </h2>
          </div>
          <Button
  className="more-btn"
  as="a"
  href="/blog"
>
  More Blog
</Button>

        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }} // animate every time
        >
          <Row>
            {blogPosts.map((post) => (
              <Col md={4} sm={12} key={post.id} className="mb-4">
                <motion.div variants={cardVariants(post.animation)}>
                  <Card className="blog-card">
                    <Card.Img
                      variant="top"
                      src={post.image}
                      className="blog-img"
                    />
                    <Card.Body>
                      <span className="category">{post.category}</span>
                      <Card.Title className="blog-title">
                        {post.title}
                      </Card.Title>
                      <div className="author d-flex align-items-center mt-3">
                        <span className="author-icon">{post.authorIcon}</span>
                        <span className="author-name">By {post.author}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  );
};

export default BlogSection;
